Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Translation", {
    enumerable: true,
    get: function() {
        return Translation;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class Translation {
    constructor(def){
        _define_property(this, "uid", void 0);
        _define_property(this, "locale", void 0);
        _define_property(this, "internal", void 0);
        this.uid = def.uid;
        this.locale = def.locale;
        this.internal = def.internal;
    }
}
